import React, { useState, useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import Sidebar from './sidebar';
import Navbar from './navbar';
import { HelpProvider } from '../context/help-context';
import HelpDrawer from './help-drawer';

const DashboardLayout = () => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [collapsed, setCollapsed] = useState(false);
    const location = useLocation();
    const pathname = location.pathname;

    const toggleSidebar = () => {
        setSidebarOpen(!sidebarOpen);
    };

    const toggleCollapse = () => {
        setCollapsed(!collapsed);
    };

    useEffect(() => {
        setSidebarOpen(false);
    }, [pathname]);

    return (
        <HelpProvider>
            <div className="w-full min-h-screen flex justify-between overflow-auto font-poppins relative">
                {sidebarOpen && (
                    <div
                        className="fixed w-full h-full inset-0 bg-black/60 lg:hidden z-50"
                        onClick={() => setSidebarOpen(false)}
                    />
                )}

                <HelpDrawer />

                <div
                    className={`fixed max-h-screen overflow-hidden transition-all duration-300 
                    ${collapsed ? 'xl:w-[80px] lg:w-[80px]' : 'xl:w-[15%] lg:w-[20%]'} 
                    md:w-3/12 xs:w-3/6 w-2/3 bg-lightGray z-30 
                    ${sidebarOpen ? 'translate-x-0' : '-translate-x-full'} 
                    lg:relative lg:translate-x-0`}
                >
                    <Sidebar collapsed={collapsed} toggleCollapse={toggleCollapse} />
                </div>

                <div className="flex-1 w-full max-h-screen bg-white custom-scrollbar overflow-auto">
                    <div className="sticky lg:z-40 z-40 top-0 w-full">
                        <Navbar toggleSidebar={toggleSidebar} toggleCollapse={toggleCollapse} collapsed={collapsed} />
                    </div>
                    <Outlet context={{ collapsed }} />
                </div>
            </div>
        </HelpProvider>
    );
};

export default DashboardLayout;